import React from "react";
import { FiSearch } from "react-icons/fi";

export default function SearchIcon({
  onChange = ()=>{},
  placeholder,
  type,
  backgroundColor,
  borderRadius,
  border,
  width,
  children,
  margin = '0px'
}) {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "end",
        width:'100%',
        // alignItems:'center'
      }}
    >
      <div
        className="actsearch_box1 d-flex align-items-center"
        style={{ backgroundColor, borderRadius, border,width, margin }}
      >
        <FiSearch  color="rgba(136, 136, 136, 1)" size={'20px'} className="me-2"/>
        <input
          style={{ backgroundColor }}
          placeholder={placeholder}
          type={type}
          className=""
          onChange={onChange}
        />
        {children}
      </div>
      
    </div>
  );
}
